





















































import Vue from 'vue';
export default Vue.extend({
    name: 'AceEditor',
    props: {
        readOnly: {
            type: Boolean,
            default: false,
        },
        initData: String,
        width: {
            type: String,
            default: '300',
        },
        height: {
            type: String,
            default: '320',
        }
    },
    data() {
        return {
            staticData: '',
            editorOption: {
                enableBasicAutocompletion: true,
                // enableSnippets: true,
                enableLiveAutocompletion: true,
                tabSize: 4
            },
            code: 'console.log(data)',
            editor: {},
            aceRef: {},
        }
    },
    watch: {
        initData(newInitData) {
            this.initStaticData();
        }
    },
    components: {
        Editor: require('vue2-ace-editor'),
    },
    methods: {
        editorInit: () => {
            // 初始化语言工具，只有初始化了才能设置只能提示和自动完成
            require("brace/ext/language_tools");
            // 设置语言模式
            require('brace/mode/javascript');
            // 设置主题
            require('brace/theme/dawn');
            // 添加索搜的包
            // require("brace/ext/searchbox");
        },
        initStaticData(){
            if (!this.initData) {
                this.staticData = 
                `[]`;
            } else {
                this.staticData = this.initData;
            }
        },
        onMounted(editor) {
            console.log(editor);
        },
        /**
         * 取得ace的引用
         */
        initAceRef() {
            this.aceRef = this.$refs.myEditor;
        },
        /**
         * 编辑器失焦事件
         */
        registerAceBlur(aceEditor: any): void {
            aceEditor.on("blur", () => {
                this.$emit('editorBlur', this.staticData);
            })
        },
        /**
         * 初始化ace的属性配置
         */
        initAceConfig() {
            let aceEditor: any = {};
            if ((this.aceRef as any).editor) {
                aceEditor = this.aceRef.editor;
            }
            // 设置为只读
            if (this.readOnly) {
               aceEditor.setReadOnly(true);
            }
            this.registerAceBlur(aceEditor);
        },
        /**
         * 提交编辑器的实例
         */
        initEmitOriginEditor() {
            this.$emit('onMountedEditor', (this.aceRef as any).editor);
        }
    },
    created() {
    },
    mounted() {
        this.initAceRef();
        this.initAceConfig();
        this.initStaticData();
        this.initEmitOriginEditor();
    },
     beforeDestroy() {
         this.aceRef = null;
     }
})
